<template>
    <!-- <CustomHeader :text="$t('common.deposite')" /> -->
    <div class="deposit_container">
        <div class="channel_container">
            <div class="channel_text">{{ $t('common.paymentChannel') }}：</div>
            <div class="channel_list">
                <div class="channel_card" v-for="item in dataSet.channelList" :key="item.name"
                    :class="dataSet.activeChannel.id == item.id ? 'active_channel' : ''" @click="selectChannel(item)">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div v-if="props.dataSet.activeChannel.name == 'erc20' || props.dataSet.activeChannel.name == 'arb'">
            <ErcCard :address="props.dataSet.ercCode" :minAmount="props.dataSet.minErcAmount" :maxAmount="props.dataSet.maxErcAmount"/>
        </div>
        <div v-else>
            <div class="bonus_select">
                <van-checkbox v-model="selecTopup">{{ $t('deposit.promotions') }}</van-checkbox>
            </div>

            <div class="sub_container">
                <div>
                    <div class="balance_text">{{ $t('deposit.depositAmount') }}</div>
                </div>
                <div class="deposit_notice">
                    <img src="@/assets/loginRegister/notice.png" alt="">
                    {{ $t('deposit.bonuseRedeem') }} {{ dataSet.turnOverValue }}x {{ $t('deposit.invoicing') }}
                </div>
                <InputField v-model="selectedAmount"
                    :labelText="$t('deposit.valueLabel') + ' (' + dataSet.min_amount + ' ~ ' + dataSet.max_amount + ')'"
                    :isTopupVisible="selecTopup" :giftAmount="dataSet.giftAmount" />
                <div class="balance_text_sec">
                    {{ $t('deposit.youWillReceive') }}:
                    <span class="highlight">R$ {{ formatCurrency(selectedAmount) }}</span>
                </div>
                <div v-if="dataSet.activeChannel.name == 'uupay' || dataSet.activeChannel.name == 'qqpay'">
                    <div class="input_field">
                        <div class="inputLabel">CPF ID</div>
                        <div class="input_container">
                            <van-field v-model="cpfID" type="number" :placeholder="$t('withdraw.cpfIdPlaceholder')">
                                <template #right-icon>
                                    <div class="right-wrapper">
                                        <van-icon v-if="cpfID" name="clear" class="custom-clear"
                                            @click.stop="onClear" />
                                        <van-icon name="credit-pay" />
                                    </div>
                                </template>
                            </van-field>
                        </div>
                    </div>
                    <div class="errorText" v-if="dataSet.showCPFIdError">
                        {{ $t('withdraw.cpfErrorText') }}</div>
                </div>

                <van-row class="amount_card_list">
                    <van-col span="8" v-for="item in dataSet.amountList" :key="item.fillValue" style="padding: 8px;">
                        <AmountCard :amount="item.fillValue" :isActiveAmount="dataSet.selectedAmount == item.fillValue"
                            :giftRatio="item.giftRatio" :isTopupVisible="selecTopup"
                            @handleCardClick="selectAmountCard(item)" />
                    </van-col>
                </van-row>

                <van-row class="note_text" v-if="selecTopup">
                    <van-col span="4">
                        <img src="@/assets/deposit/deposit_bonus.png" alt="">
                    </van-col>
                    <van-col span="20"> {{ $t('common.deposite') }} R$ {{ formatCurrency(selectedAmount) }} {{
                        $t('deposit.receive') }}
                        R$
                        {{ formatCurrency(dataSet.giftAmount) }}
                        {{ $t('deposit.asaGift') }}.</van-col>
                </van-row>
            </div>


            <div class="btn_container">
                <MainButton :title="$t('common.deposite')" :activeStatus="dataSet.isFillField"
                    @click="confirmDeposit" />
            </div>
            <div class="balance_text_sec" style="display: flex;justify-content: center;">
                <span @click="showIntroduction">{{ $t('deposit.introduction') }} {{ '>' }}</span>
            </div>
        </div>
        
        <van-popup v-model:show="showIntroPopup" position="center"
            :style="{ background: 'transparent', width: '90%', maxWidth: '380px' }" round closeable close-icon="cross">
            <div class="intro-popup">
                <!-- Header -->
                <div class="intro-header">
                    {{ $t('deposit.introduction') }}
                </div>

                <!-- Content -->
                <div class="intro-content">
                    <div class="intro-section">
                        <div class="intro-subtitle">
                            {{ $t('deposit.problemIdentified') }}
                        </div>
                        <div class="intro-text">
                            {{ $t('deposit.withdrawCondition') }}
                        </div>
                    </div>

                    <div class="intro-section">
                        <div class="intro-subtitle">
                            {{ $t('deposit.betInstructions') }}
                        </div>
                        <div class="intro-text">
                            <p v-html="$t('deposit.betInstructionsText')"></p>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script setup lang="ts">
import CustomHeader from '@/components/common/customHeader.vue'
import { ref, watch, defineProps, defineEmits } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import MainButton from '../components/common/mainButton.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import ErcCard from './components/ercCard.vue';
const props = defineProps<{
    dataSet: DepositData
}>()
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const cpfID = ref(props.dataSet.cpfID)
const showIntroPopup = ref(false)
const emit = defineEmits(['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'])
const selectChannel = (item: PayChannel) => {
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const showIntroduction = () => {
    showIntroPopup.value = true
}
const onClear = () => {
    cpfID.value = ''
    emit('updateCpfID', '')
}
</script>
<style scoped>
.deposit_container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 20px;
}

.channel_container {
    border-radius: 10px;
}

.channel_text {
    color: #f1bae0;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 10px;
}

.channel_list {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 10px 10px 10px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    background: #40294f;
    color: #8b6e8b;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 4px;
    margin-right: 10px;
    font-size: 13px;
    height: 30px;
    width: 100%;
}

.active_channel {
    background: #ff49a3;
    color: #ffffff;
    border-radius: 5px;
    width: 100%;
}

.deposit_notice {
    display: flex;
    align-items: center;
    border-radius: 10px;
    color: #ffffff99;
    font-size: 14px;
    /* margin: 10px 0px 0; */
    background-color: #ffffff26;
    padding: 10px;
}

.deposit_notice img {
    width: 20px;
    opacity: 0.5;
    height: 18px;
    padding-right: 10px;
}

.amount_card_list {
    padding: 15px 0;
}

.btn_container {
    padding: 20px 0px 0px 0px;
}

.bonus_select {
    padding: 10px 10px;
}

.bonus_select>>>.van-checkbox__label {
    color: #c08eba;
    font-size: 14px;
}

.bonus_select>>>.van-checkbox__icon--round {
    font-size: 15px;
    background: #fff;
    border-radius: 30px;
}

.bonus_select>>>.van-checkbox__icon--checked .van-icon {
    background-color: #ff49a3 !important;
    border-color: #ff49a3 !important;
}

.note_text {
    padding: 10px;
    border-radius: 10px 10px;
    margin: 10px 0;
    background-color: #ffffff14;
    font-size: 12px;
    color: #ffffffa6;
}

.note_text .van-col {
    display: flex;
    align-items: center;
}

.note_text img {
    width: 35px;
}

.line {
    margin-top: 5px;
    height: 0.5px;
    width: 100%;
    background: rgba(255, 255, 255, 0.25);
    ;
}

.sub_container {
    background-color: #3e2e4b;
    border-radius: 10px;
    padding: 0 10px;
}

.sub_container ::v-deep .van-field {
    border-radius: 5px;
    /* padding: 2vh !important */
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.amount_card {
    /* border-radius: 5px; */
}

.input_field>>>.van-field {
    border-radius: 10px;
    background-color: #ffffff26;
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
    color: #ffffffa6 !important;
    font-size: 12px;

}

.input_field {
    padding: 10px 0;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
}

.errorText {
    color: red;
    font-size: 12px;
}

.balance_text {
    color: #ffffffd9;
    font-size: 16px;
    padding: 10px 0 10px 0;
}

.balance_text_sec {
    color: #c08eba;
    font-size: 14px;
    padding: 10px 0 0 0;
}

.highlight {
    color: #ffcb52;
    font-weight: bold;
}

.input_container>>>.van-field {
    border-radius: .0188rem;
    background: #2c1d31 !important;
    border: 1px solid #65436f;
    color: #ffffffd9;
    padding: 8px 10px !important;
    margin-top: 10px;
    border-radius: 8px;
}


.input_container ::v-deep(.van-field__control) {
    font-size: 15px !important;
    color: #ffffffd9 !important;
    font-weight: bold;
}

.input_container::v-deep(.van-field__control::placeholder) {
    color: #ffffff40 !important;
    font-size: 12px !important;
}

.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.intro-popup {
    width: 100%;
    max-width: 380px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.intro-header {
    background: linear-gradient(90deg, #c854ad 0%, #432e4f 100%);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    padding: 14px;
}

.intro-content {
    background-color: #392942;
    padding: 16px;
    font-size: 11px;
    color: #ffffffcc;
    line-height: 1.6;
}

.intro-subtitle {
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 8px;
}

.intro-text {
    color: #cccccc;
}

.van-popup__close-icon {
    color: #fff;
    top: 12px;
    right: 12px;
}

@media (min-width: 1440px) {

    .channel_text,
    .channel_card,
    .balance_text,
    .sub_container,
    .deposit_notice,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default,
    .amount_card,
    .bonus_select ::v-deep .van-checkbox__label,
    .active_channel {
        font-size: 1.8vh !important;
    }

    .deposit_notice {
        padding: 15px;
    }
}

@media (min-width: 1920px) {

    .channel_text,
    .channel_card,
    .balance_text,
    .sub_container,
    .deposit_notice,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default,
    .amount_card,
    .bonus_select ::v-deep .van-checkbox__label,
    .active_channel {
        font-size: 1.8vh !important;
    }

    .deposit_notice {
        padding: 15px;
    }
}
</style>